<template>

    <!--
    @TODO: | Remove "answer-list-evaluation-btn" class from the following div, but don't forget
    @TODO: | to find all references to it (in the whole project: SCSS, VUE and JS files)
    @TODO: | and add references to "answer-list-assessment-stopped" as well.
    @TODO: | We must keep references to "answer-list-evaluation-btn", because we still have
    @TODO: | AnswerListEvaluationBtn.vue that contains that class, so we just have to add another
    @TODO: | new reference to "answer-list-assessment-stopped".
    @TODO: | Then we can remove "answer-list-evaluation-btn" class from this div.
    -->

    <div class="answer-list-assessment-stopped answer-list-evaluation-btn">

        <!-- ---------------------------------------------------- -->
        <!-- Assessment stopped ("Start New Assessment" button)   -->
        <!-- ---------------------------------------------------- -->

        <div class="evaluation-btn-container" v-if="mustShowUrgentPopup === false">
            <div class="btn-start-new" v-if="getCurrentAssessmentStatus === getAssessmentStatuses.ASSESSMENT_STOPPED">
                <v-btn @click="goToHomePage" id="btnAssessmentStopped" color="primary" block class="btn">{{text("api.chatbot.btn.startNewAssessment")}}</v-btn>
            </div>
        </div>
    </div>
</template>

<!-- ################################################################## -->

<script>
    import {mapGetters} from 'vuex';

    export default {
        name: 'AnswerListEvaluationBtn',

        computed: {
            ...mapGetters({
                getCurrentAssessmentStatus: 'ChatBotStore/getCurrentAssessmentStatus',
                getAssessmentStatuses: 'ChatBotStore/getAssessmentStatuses',
                mustShowUrgentPopup: 'AssessmentAlertsStore/getMustShowUrgentPopup'
            })
        },
        updated: function () {
            this.$nextTick(function () {
                if (this.getCurrentAssessmentStatus === this.getAssessmentStatuses.ASSESSMENT_STOPPED) {
                    console.log("ASSESSMENT_STOPED - updated.");
                    this.$emit('onAnswerListUpdated');
                }
            });
        },

        methods: {
            goToHomePage() {
                this.$router.push({name: 'PF_ChatBotPage'}).then(() => { // Go to Chatbot's home page (product list).
                    sessionStorage.removeItem("crtChatbotSection");
                    window.location.reload();
                });
            }
        }
    }
</script>

<!-- ################################################################## -->

<style lang="scss" scoped>


    .answer-item {
        display: inline-block;
        border: 1px solid #d3d5d9;
        border-radius: 20px;
        padding: 10px 20px;
        color: #a43a45;
        cursor: pointer;
        margin-right: 15px;
        margin-bottom: 10px;
    }

    .answer-list-evaluation-btn {
        width: 100%;

        .btn-start-new {
            text-align: center !important;

            .btn {
                color: #ffffff !important;
                border-radius: 20px;
                text-transform: none;
            }

        }
    }


    @media only screen and (max-width: 599px) {
        .evaluation-btn-container {
            margin: 0 16px;
        }
    }
    @media only screen and (min-width: 600px) {
        .evaluation-btn-container{
            margin: 0 24px;
        }
    }
</style>



// WEBPACK FOOTER //
// src/pathfinder/components/chatbot/answer-list/AnswerListAssessmentStopped.vue